/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Bucket_SmallInputs */

const en_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small Bucket`)
};

const es_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubo pequeño`)
};

const de_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleiner Eimer`)
};

const zh_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小桶`)
};

const ar_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلة صغيرة`)
};

const fr_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petit seau`)
};

const vi_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xô nhỏ`)
};

const sw_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndoo Ndogo`)
};

const th_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถังเล็ก`)
};

const bs_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mala kanta`)
};

const ja_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スモールバケット`)
};

const ko_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스몰 버킷`)
};

const pt_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balde pequeno`)
};

const it_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestino piccolo`)
};

const sv_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liten hink`)
};

const nl_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine emmer`)
};

const da_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lille kurv`)
};

const nb_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liten kurv`)
};

const fi_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieni ämpäri`)
};

const pl_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mały koszyk`)
};

const ru_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маленькая корзина`)
};

const tr_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küçük Kova`)
};

const hi_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छोटी बाल्टी`)
};

const id_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember Kecil`)
};

const ms_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baldi Kecil`)
};

const cs_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malý košík`)
};

const el_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μικρός κουβάς`)
};

const he_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דלי קטן`)
};

const af_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klein emmer`)
};

const hu_prices_label_bucket_small = /** @type {(inputs: Prices_Label_Bucket_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kis vödör`)
};

/**
* | output |
* | --- |
* | "Small Bucket" |
*
* @param {Prices_Label_Bucket_SmallInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_bucket_small = /** @type {((inputs?: Prices_Label_Bucket_SmallInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Bucket_SmallInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_bucket_small(inputs)
	if (locale === "de") return de_prices_label_bucket_small(inputs)
	if (locale === "zh") return zh_prices_label_bucket_small(inputs)
	if (locale === "ar") return ar_prices_label_bucket_small(inputs)
	if (locale === "fr") return fr_prices_label_bucket_small(inputs)
	if (locale === "vi") return vi_prices_label_bucket_small(inputs)
	if (locale === "sw") return sw_prices_label_bucket_small(inputs)
	if (locale === "th") return th_prices_label_bucket_small(inputs)
	if (locale === "bs") return bs_prices_label_bucket_small(inputs)
	if (locale === "ja") return ja_prices_label_bucket_small(inputs)
	if (locale === "ko") return ko_prices_label_bucket_small(inputs)
	if (locale === "pt") return pt_prices_label_bucket_small(inputs)
	if (locale === "it") return it_prices_label_bucket_small(inputs)
	if (locale === "sv") return sv_prices_label_bucket_small(inputs)
	if (locale === "nl") return nl_prices_label_bucket_small(inputs)
	if (locale === "da") return da_prices_label_bucket_small(inputs)
	if (locale === "nb") return nb_prices_label_bucket_small(inputs)
	if (locale === "fi") return fi_prices_label_bucket_small(inputs)
	if (locale === "pl") return pl_prices_label_bucket_small(inputs)
	if (locale === "ru") return ru_prices_label_bucket_small(inputs)
	if (locale === "tr") return tr_prices_label_bucket_small(inputs)
	if (locale === "hi") return hi_prices_label_bucket_small(inputs)
	if (locale === "id") return id_prices_label_bucket_small(inputs)
	if (locale === "ms") return ms_prices_label_bucket_small(inputs)
	if (locale === "cs") return cs_prices_label_bucket_small(inputs)
	if (locale === "el") return el_prices_label_bucket_small(inputs)
	if (locale === "he") return he_prices_label_bucket_small(inputs)
	if (locale === "af") return af_prices_label_bucket_small(inputs)
	if (locale === "hu") return hu_prices_label_bucket_small(inputs)
	return en_prices_label_bucket_small(inputs)
});